import { render, staticRenderFns } from "./NewPermissionList.vue?vue&type=template&id=19a5c1ea&scoped=true&"
import script from "./NewPermissionList.vue?vue&type=script&lang=js&"
export * from "./NewPermissionList.vue?vue&type=script&lang=js&"
import style0 from "./NewPermissionList.vue?vue&type=style&index=0&id=19a5c1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5c1ea",
  null
  
)

export default component.exports